import type { ReactNode } from "react";
import { useSession } from "../lib/session";
import { BrandGlyph } from "./Icon";
import { ThemeToggle } from "./AppShell";

const LEDGER: Array<[string, string]> = [
  ["Courses", "Terraform · PowerShell · Ansible · Postman · Cloudflare · ISO 27001 · Cyber Essentials"],
  ["Levels", "Foundation → Capstone"],
  ["Graded labs", "One per module"],
];

/**
 * The frame for every screen you can reach without a full session. The left column states what
 * the course is; the right column carries one job at a time.
 */
export function AuthLayout({
  heading,
  blurb,
  children,
}: {
  heading: string;
  blurb?: string;
  children: ReactNode;
}) {
  const { settings } = useSession();
  return (
    <div className="auth">
      <aside className="auth-aside">
        <div className="auth-aside-head">
          <span className="brand">
            <BrandGlyph className="brand-glyph" />
            <span className="brand-name">
              The Terraformed <span>Life</span>
            </span>
          </span>
          <h1>Learn by building it, not by reading about it.</h1>
          <p>
            Every module ends in a lab in your own sandbox: write the code, run it, and let the
            grader tell you what is still wrong. Finish every module of a course, capstone
            included, and its certificate is yours.
          </p>
        </div>
        <dl className="auth-ledger">
          {LEDGER.map(([term, value]) => (
            <div key={term}>
              <dt>{term}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
      </aside>

      <div className="auth-panel">
        <div className="auth-form">
          <div className="row-between">
            <h2>{heading}</h2>
            <ThemeToggle />
          </div>
          {blurb ? <p>{blurb}</p> : null}
          {children}
          <p className="hint">
            {settings.brand}
            {settings.emailEnabled ? "" : " — email is not configured, so reset links come from an administrator."}
          </p>
          <p className="hint">
            <a href="https://terraformed.dev/terms" target="_blank" rel="noopener">Terms</a>
            {" · "}
            <a href="https://terraformed.dev/covenant" target="_blank" rel="noopener">Learners' Covenant</a>
            {" · "}
            <a href="https://terraformed.dev/privacy" target="_blank" rel="noopener">Privacy</a>
            {" · "}
            <a href="https://terraformed.dev/licence" target="_blank" rel="license noopener">Licence</a>
          </p>
        </div>
      </div>
    </div>
  );
}
